export default "__VITE_ASSET__0783eb5a__"